import axios from "../axios"
import { IDictTypeListParam } from "./dict.types"

/**
 * 字典类型分页列表 
 */
export function dictTypeList(params: IDictTypeListParam) {
    return axios({
        method: 'post',
        url: '/dict/type/findPage',
        params,
    })
}

/**
 * 新增或者编辑字典类型
 */
export function dictTypeCreateEdit(params) {
    return axios({
        method: 'post',
        url: '/dict/type/save',
        data: params,
    })
}

/**
 * 字典类型删除
 */
export function dictTypeDel(params: { id: number }) {
    return axios({
        method: 'get',
        url: '/dict/type/del',
        params,
    })
}
